import { dimensions as ionDimensions } from './ion/dimensions'

export const spacing = {
  '2xl': '50px',
  '2xm': '25px',
  '3xl': '60px',
  '15xm': '22px',
  ion: ionDimensions.spacing,
  lg: '30px',
  md: '15px',
  sm: '10px',
  xl: '40px',
  xm: '20px',
  xs: '5px',
} as const
